export const eventTypes = [
  "triggered-event",
  "datapoint-event",
  "device-online",
  "device-offline",
  "intervention-request",
  "teleop-session-record",
  "port-forwarding-session-record",
  "command-request",
  "command-response",
  "command-delivery",
  "intervention-response",
  "custom",
  "comment",
  "system",
  "annotation",
  "task-summary",
  "stateful",
] as const;
